function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.83508 10.7797C6.94429 10.8657 7.09186 10.8858 7.21878 10.8256C7.34569 10.7682 7.42538 10.6449 7.42538 10.5072V8.1151C9.72754 8.1237 11.3184 8.28433 13.2457 11.5914C13.3106 11.7033 13.4317 11.7692 13.5615 11.7692C13.591 11.7692 13.6235 11.7664 13.653 11.7578C13.8124 11.7176 13.9216 11.5771 13.9216 11.4193V11.1411C13.9364 8.80348 13.9629 3.98484 7.42538 3.75538V1.3518C7.42538 1.217 7.34569 1.09079 7.21878 1.03343C7.09186 0.976064 6.94134 0.993274 6.83508 1.07932L1.13282 5.65415C1.05018 5.72012 1 5.82051 1 5.92377C1 6.02989 1.04722 6.12741 1.12987 6.19338L6.83508 10.7797ZM6.70227 2.09754V4.09957C6.70227 4.29174 6.86165 4.4495 7.0594 4.45236C9.77771 4.47818 11.5397 5.28415 12.4488 6.92191C13.0214 7.94874 13.1601 9.16201 13.1926 10.1802C11.3361 7.56153 9.59177 7.41525 7.06235 7.41238C6.9679 7.41238 6.87345 7.44967 6.80557 7.51564C6.73768 7.58161 6.69932 7.67052 6.69932 7.76518V9.76433L1.92972 5.92377L6.70227 2.09754Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.4
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9231 14.6323V13.0132C13.9231 12.8086 13.7599 12.6431 13.5581 12.6431C13.3563 12.6431 13.1931 12.8086 13.1931 13.0132V14.2651H1.72998V7.83109C1.72998 7.62645 1.56678 7.46094 1.36499 7.46094C1.16321 7.46094 1 7.62645 1 7.83109V14.6292C1 14.8339 1.16321 14.9994 1.36499 14.9994H13.5581C13.7599 14.9994 13.9231 14.8339 13.9231 14.6323Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.4
});

function SvgImporticon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImporticon);
export default __webpack_public_path__ + "static/media/import.icon.d0282cd7.svg";
export { ForwardRef as ReactComponent };